import { render, staticRenderFns } from "./AdminBookingRequestForm.vue?vue&type=template&id=ba362210"
import script from "./AdminBookingRequestForm.vue?vue&type=script&lang=js"
export * from "./AdminBookingRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports